<template>
  <div class="container1">
    <head-page/>
    <payment-result></payment-result>
    <!-- PaymentSuccess  -->
    <footer-page></footer-page>
  </div>
</template>

<script>
import HeadPage from '@/components/HeadPage.vue'
import PaymentResult from './components/PaymentResult.vue'
import FooterPage from '@/components/FooterPage.vue'
export default {
  name: 'PaymentSuccess',
  components: {
    HeadPage,
    PaymentResult,
    FooterPage,
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped></style>
